import React from "react";

import { Col, Row } from "react-bootstrap";

import LazyIframe from "./LazyIframe";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import "../../styles/realStories.scss";

const EquityProtectAssetsVideos = () => {
  return (
    <>
      <Row className="">
        <Col>
          <div className=" text-center">
            <div className="mb-5">
              <p className="notify_header">Videos</p>
              <h2 className="sub_header">Videos on title fraud</h2>
            </div>
          </div>
        </Col>
      </Row>
      <Row className="d-flex justify-content-center align-items-center">
        <Col xs={12} sm={12} md={6} lg={4} className=" p-2 ">
          <div className="realStoryWrapper">
            <LazyIframe
              caption="Equity Protect May"
              id="q75Tsqzww4I"
              time="(0:44)"
              description="EquityProtect provides home equity protection against home title theft and fraud with comprehensive services and 24/7 monitoring."
              thumbnailUrl="https://i.ytimg.com/vi/q75Tsqzww4I/default.jpg"
              uploadDate="2024-05-15T10:21:55Z"
              duration="PT45S"
              embedUrl="https://www.youtube.com/embed/q75Tsqzww4I"
              interactionCount="66"
            />
          </div>
        </Col>
        <Col xs={12} sm={12} md={6} lg={4} className=" p-2">
          <div className="realStoryWrapper">
            <LazyIframe
              caption="Equity Protect"
              id={"uZnK4lq3SW4"}
              time="(0:29)"
              description="EquityProtect video on home equity protection to stop title fraud and theft."
              thumbnailUrl="https://i.ytimg.com/vi/uZnK4lq3SW4/default.jpg"
              uploadDate="2024-05-20T16:59:33"
              duration="PT30S"
              embedUrl="https://www.youtube.com/embed/uZnK4lq3SW4"
              interactionCount="70"
            />
          </div>
        </Col>
        <Col xs={12} sm={12} md={6} lg={4} className=" p-2">
          <div className="realStoryWrapper">
            <LazyIframe
              caption="Equity Protect - Hacker"
              time="(0:12)"
              id={"WKkZdtG6CCE"}
              description="EquityProtect video on home equity protection against hackers, title fraud, and theft."
              thumbnailUrl="https://i.ytimg.com/vi/WKkZdtG6CCE/default.jpg"
              uploadDate="2024-05-29T11:58:06Z"
              duration="PT13S"
              embedUrl="https://www.youtube.com/embed/WKkZdtG6CCE"
              interactionCount="55"
            />
          </div>
        </Col>
        <Col xs={12} sm={12} md={6} lg={4} className=" p-2 ">
          <div className="realStoryWrapper">
            <LazyIframe
              caption="Equity Protect - Cyber Security"
              time="(0:10)"
              id="16zkwkQXMso"
              description="EquityProtect video on cyber security for home equity protection against title fraud and theft."
              thumbnailUrl="https://i.ytimg.com/vi/16zkwkQXMso/default.jpg"
              uploadDate="2024-05-29T11:54:29Z"
              duration="PT11S"
              embedUrl="https://www.youtube.com/embed/16zkwkQXMso"
              interactionCount="37"
            />
          </div>
        </Col>
        <Col xs={12} sm={12} md={6} lg={4} className=" p-2 ">
          <div className="realStoryWrapper">
            <LazyIframe
              caption="Equity Protect - Shield"
              time="(0:10)"
              id="DqyzAftdzyw"
              description="EquityProtect home shield and title protection"
              thumbnailUrl="https://i.ytimg.com/vi/DqyzAftdzyw/default.jpg"
              uploadDate="2024-05-29T11:51:04Z"
              duration="PT11S"
              embedUrl="https://www.youtube.com/embed/DqyzAftdzyw"
              interactionCount="49"
            />
          </div>
        </Col>
        <Col xs={12} sm={12} md={6} lg={4} className=" p-2">
          <div className="realStoryWrapper">
            <LazyIframe
              caption="EquityProtect protecting you"
              time="(1:30)"
              id={"uuslWbcjIlY"}
              description="EquityProtect does what other don't do, we stop the crime before it happens."
              thumbnailUrl="https://i.ytimg.com/vi/uuslWbcjIlY/default.jpg"
              uploadDate="2024-03-05T04:47:05Z"
              duration="PT1M31S"
              embedUrl="https://www.youtube.com/embed/uuslWbcjIlY"
              interactionCount="411182"
            />
          </div>
        </Col>
      </Row>
    </>
  );
};
export default React.memo(EquityProtectAssetsVideos);
